<template>
  <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto px-6 pt-6  pb-20">
    <div class="grid grid-cols-1">
      <div>
          <Nav />
          <div  class="bg-[#2B2C32] rounded-lg px-5 mt-1 pb-3 mb-[90px]">
            <div v-if="vg_selectedLocation.id">
              <div class="flex gap-3 w-full items-start mb-1">
                  <div class="w-full">
                      <div class="input-wrapper xl:w-1/4">
                          <h2 class="text-white font-semibold text-[24px] mt-3">Online Payments</h2>
                          <!-- <label class="text-xs mb-1 font-normal">Payment Processor</label> -->
                          <select v-model="currentOnlineProcessor" class="block rounded bg-gray-black border-none w-full text-sm text-theme-white">
                            <option disabled value=null>--Select--</option>
                            <option :value="processors.name" v-bind:key="'payment_processor_'+processors.name" v-for="processors in paymentProcessors">{{ processors.name }}</option>
                          </select>
                      </div>
                      <div v-if="currentOnlineProcessor">
                        <div v-if="currentOnlineProcessor=='moneris'">
                          <OnlineMoneris @doUpdated="doUpdated" :reloadIt="reloadIt" />
                        </div>
                        <div v-else>
                          <AccessToken />
                          <div class="h-[2px] bg-theme-grey w-full"></div>
                        </div>
                      </div>
                  </div>
              </div>

              <div class="flex gap-3 w-full items-start mb-1">
                  <div class="w-full">
                      <div class="input-wrapper xl:w-1/4">
                          <h2 class="text-white font-semibold text-[24px] mt-3">In-Store Payments</h2>
                          <!-- <label class="text-xs mb-1 font-normal">Payment Processor</label> -->
                          <select v-model="currentInStoreProcessor" class="block rounded bg-gray-black border-none w-full text-sm text-theme-white">
                            <option disabled value=null>--Select--</option>
                            <option :value="processors.name" v-bind:key="'payment_processor_'+processors.name" v-for="processors in paymentProcessors">{{ processors.name }}</option>
                          </select>
                      </div>
                      <div v-if="currentInStoreProcessor">
                        <div>
                          <div v-if="currentInStoreProcessor=='moneris'">
                            <InStoreMoneris @doUpdated="doUpdated" :reloadIt="reloadIt" />
                          </div>
                          <div v-else>
                            <AccessToken />
                          </div>
                        </div>

                        <div v-if="vg_selectedLocation.id">
                          <PaymentTerminals/>
                        </div>
                      </div>
                    </div>
              </div>
            </div>
            <div v-else class="bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5">
              <p class="text-center text-theme-red mt-3">Please select a location.</p>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
    import {defineComponent, ref, shallowRef} from "vue"
    import Nav from '@/views/Location/Integrations/Nav.vue';
    import PaymentTerminals from '@/views/Location/Integrations/PaymentTerminals/Index.vue';
    import AccessToken from '@/views/Location/Integrations/AccessToken/Index.vue';
    import OnlineMoneris from '@/views/Location/Integrations/Moneris/Online.vue'
    import InStoreMoneris from '@/views/Location/Integrations/Moneris/InStore.vue'
    import LocationIntegrationApis from "@/controllers/LocationIntegrationApis";
    import { mapGetters } from "vuex";
    

    export default defineComponent({
        name: "LocationDevicesPos",
        components: {
          Nav,
          PaymentTerminals,
          AccessToken,
          OnlineMoneris,
          InStoreMoneris
        },
        setup(){
          const loading = false
          const reloadIt = ref(false)
          const paymentProcessors = ref([
            {
              name: 'clover'
            },
            {
              name: 'moneris'
            },
          ])
          const currentOnlineProcessor =ref(null)
          const currentInStoreProcessor =ref(null)

          return {
            loading,
            reloadIt,
            paymentProcessors,
            currentOnlineProcessor,
            currentInStoreProcessor
          }
        },

        async mounted(){
          this.loading =true
          let {data} = await LocationIntegrationApis.fetchPaymentProvider()
          if(data?.payload){
            this.currentOnlineProcessor = data.payload.ecommercePaymentProvider
            this.currentInStoreProcessor = data.payload.instorePaymentProvider
          }
          this.$nextTick(() => {
            this.loading = false
          })
        },

        watch: {
          async currentOnlineProcessor(){
            if(!this.loading && (this.currentInStoreProcessor || this.currentOnlineProcessor)){
              let data = {
                instorePaymentProvider: this.currentInStoreProcessor?this.currentInStoreProcessor:null,
                ecommercePaymentProvider: this.currentOnlineProcessor?this.currentOnlineProcessor:null
              }
              await LocationIntegrationApis.updatePaymentProvider(data)
            }
          },
          async currentInStoreProcessor(){
            if(!this.loading && (this.currentInStoreProcessor || this.currentOnlineProcessor)){
              let data = {
                instorePaymentProvider: this.currentInStoreProcessor?this.currentInStoreProcessor:null,
                ecommercePaymentProvider: this.currentOnlineProcessor?this.currentOnlineProcessor:null
              }
              console.log(data)
              await LocationIntegrationApis.updatePaymentProvider(data)
            }
          }
        },

        computed: {
          ...mapGetters({
            vg_selectedLocation: 'location/selected'
          }),
        },
      
     
        methods: {

          doUpdated(){
            this.reloadIt = !this.reloadIt
          },

           /**
           * selectedPaymentProcessors
           */
          selectedPaymentProcessors(data){  
            console.log(data)
          },

            
        },
       
   
    })


</script>
